import React from 'react'
import {tela_fluxo} from '../telas_id'
import {Card, CardTitle, CardBody, Label} from 'reactstrap'
import FadeIn from 'react-fade-in'
import './styles/estilo.css'
import {status, situacao} from '../components/Info'
import { Seguir, CheckedBox } from './styles/estilo_telas'

import { PropAccept } from '../ts/interfaces/PropTelas.interfaces';
import { addInfo, updateInfoBPO } from '../state/actions/Info_actions'
import { getStateJornada } from '../state/actions/jornada_actions'

interface State {
  unlock: boolean
}

const {REACT_APP_NAME_LECCA} = process.env



export default class Validacao extends React.Component<PropAccept, State>{
  constructor(props : PropAccept) {
    super(props)
    this.handleChange = this.handleChange.bind(this);
    this.Aceitar = this.Aceitar.bind(this);
    this.Rejeitar = this.Rejeitar.bind(this);
  }

  state = {
    unlock: true
  }

  handleChange(e : React.ChangeEvent<HTMLInputElement>){
    this.setState({unlock: e.target.checked})
  }

  componentDidMount(){
    updateInfoBPO({fase: status.tela_lgpd, situacao: situacao.sucesso});
    //document.getElementsByClassName('modal')[0].display = 'block';
  }

  Aceitar() {
    updateInfoBPO({fase: status.lgpd_aceita, situacao: situacao.sucesso});
    addInfo(tela_fluxo.validacao);
    this.props.changePasso();
  }

  Rejeitar() {
    const {id} = getStateJornada();
    updateInfoBPO({fase: status.lgpd_rejeita, situacao: situacao.sucesso});
    this.props.history.push('/rejeitar/'+id)
  }


  render(){

    const {unlock} = this.state;

    return(
      <FadeIn delay={50}>
        
        <div style={{marginTop: '20px'}}>
        <Card
          body
          >
        <CardTitle tag='h5' style={{textAlign: 'center'}}>Compartilhamento de dados</CardTitle>
        <CardBody>
        <p style={{textAlign: 'justify', textJustify: 'inter-word'}}>A {REACT_APP_NAME_LECCA} está autorizada a tratar, armazenar 
        e compartilhar os meus dados e informações, com parceiros atuais e potenciais, terceiros ou cessionários, 
        empresas coligadas e prestadores de serviços da {REACT_APP_NAME_LECCA}. Autorizo a minha fonte pagadora a fornecer 
        qualquer dado ou informação para a formalização de operação de crédito e utilização do Cartão {REACT_APP_NAME_LECCA}. 
        Concordo que meus dados e informações sejam utilizados para análises cadastrais, de crédito ou 
        para qualquer outra finalidade vinculada a concessão e utilização do cartão {REACT_APP_NAME_LECCA} e toda operação 
        de crédito a ele vinculado pelo prazo legal em vigor (atualmente 5 anos) a contar da data do pagamento.
        </p>
        <CheckedBox onChange={this.handleChange} /> <Label check> Eu li e aceito o termo </Label>
        <Seguir width='30%' unlock={unlock} onClick={this.Aceitar} />
        </CardBody>
        </Card>
        </div>
      </FadeIn>
    );

  }


}